<template>
  <b-modal
    id="promo-code-geofence"
    title="Geofence"
    size="lg"
    hide-footer
  >
    <b-tabs v-model="tab">
      <b-tab>
        <template #title>
          Pick Up
        </template>
        <promo-code-map
          :polygons="pickups"
          @path-set="$emit('pickup-selection', $event)"
        />
      </b-tab>
      <b-tab>
        <template #title>
          Drop Off
        </template>
        <promo-code-map
          :polygons="dropoffs"
          @path-set="$emit('dropoff-selection', $event)"
        />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import { BModal, BTabs, BTab } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import PromoCodeMap from './PromoCodeMap.vue'

export default {
  components: {
    BModal,
    BTabs,
    BTab,
    PromoCodeMap,
  },
  props: {
    pickups: {
      type: Array,
      default: () => [],
    },
    dropoffs: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const tab = ref(0)
    return {
      tab,
    }
  },
}
</script>

<style>

</style>
